import { render } from "./CookieWarningButton.vue?vue&type=template&id=5c5f6015"
import script from "./CookieWarningButton.vue?vue&type=script&lang=js"
export * from "./CookieWarningButton.vue?vue&type=script&lang=js"

import "./CookieWarningButton.vue?vue&type=style&index=0&id=5c5f6015&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__